import { getUserHrDocsThunkAction } from "./getUserHrDocs.thunk.action";

import { fetchClaimsThunk } from "../../../User/User Claims/thunk/fetchClaimsThunk";

import { $api } from "../../../../services/request.config";
import { getUserHrDocsAction } from "../getUserHrDocs.action";
// import { wrongAuthAunteficationAction } from "../../../AuthNumber/aunteficationAction";
// import { getUserHrDocsAction } from "../getUserHrDocs.action";

export const unepSmsConfirmationThunkAction =
    ({ smsCode, taskId, setDescription, setLoader }) =>
        async (dispatch) => {
            try {
                setLoader(true);
                const response = await $api.post(
                    `/v2/directum/document/signing/sign/task/${taskId}/confirm/sms`,
                    { smsCode },
                );
                if (response) {
                    dispatch(fetchClaimsThunk());
                    setDescription(" Подписание успешно завершено");
                    setLoader(false);
                    // dispatch(getUserHrDocsAction(null));
                    dispatch(
                        getUserHrDocsThunkAction({
                            entityType: 0,
                        }),
                    );
                }
            } catch (error) {
                setLoader(false);
                setDescription("Не удалось подписать документ");
            }
        };
